// @flow
import BaseCollection from "../base/BaseCollection";

import type TaskGroupModel from "../taskgroup/TaskGroupModel";

/**
 * Collection of taskgroup models
 */
export default class TaskGroupCollection extends BaseCollection<TaskGroupModel> {
  /**
   * Indicates if the taskgroup collection has has tasks
   */
  hasTasks(): boolean {
    return this.collection.some((taskgroup) => taskgroup.hasTasks());
  }
}
